// extracted by mini-css-extract-plugin
module.exports = {"sectionRun":"SectionRunView__sectionRun__2DobL"};